import React from 'react';
import { useInView } from 'react-intersection-observer';

const InView = ({ children, ...rest }) => {
    const { ref, inView } = useInView({
        threshold: 0,
        rootMargin: '30px'
    });

    return (
        <div ref={ref} {...rest}>
            {inView && children}
        </div>
    );
};

export default InView;
